import { useParams, useSearch } from '@tanstack/react-router';
import { useCampaign } from '@/api';
import { findReservedUserProduct } from '@/utils';
import { Address } from './Address';

/**
 * Address entry/edit screen in the campaign participation flow.
 * Thin wrapper that reads route params and delegates to the shared Address form.
 */
export function CampaignAddressEdit() {
  const { id } = useParams({ from: '/_authenticated/campaign/$id/address-edit' });
  const { addressId } = useSearch({ from: '/_authenticated/campaign/$id/address-edit' });

  const { data: campaign } = useCampaign(id);
  const reservedUserProduct = findReservedUserProduct(campaign?.userProducts);

  return (
    <Address
      campaignId={id}
      addressId={addressId}
      reservedDate={reservedUserProduct?.reservedDate ?? undefined}
    />
  );
}

export default CampaignAddressEdit;
